export default __webpack_public_path__ + "static/media/product-image-card-5.608a914c.jpg";